import { render, staticRenderFns } from "./ChangguanList.vue?vue&type=template&id=ad9eaf6e&scoped=true"
import script from "./ChangguanList.vue?vue&type=script&lang=js"
export * from "./ChangguanList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9eaf6e",
  null
  
)

export default component.exports